import { DocumentStatusKey } from "models/DocumentStatusKey";

const DocumentStatusMap: Record<DocumentStatusKey, number> = {
    [DocumentStatusKey.PLANNED]: 1,
    [DocumentStatusKey.PENDING_CONTENT]: 2,
    [DocumentStatusKey.PENDING_APPROVAL]: 3,
    [DocumentStatusKey.ACCEPTED]: 7,
    [DocumentStatusKey.REJECTED]: 4,
    [DocumentStatusKey.PREPUBLISHED]: 5,
    [DocumentStatusKey.PUBLISHED]: 6,
    [DocumentStatusKey.ERROR]: 8,
};

const DocumentStatusIdMap = Object.fromEntries(
    Object.entries(DocumentStatusMap).map(([key, value]) => [value, key])
) as Record<number, DocumentStatusKey>;

export { DocumentStatusMap, DocumentStatusIdMap };